import { configureStore } from "@reduxjs/toolkit";
import loadingReducer from "./loadingSlice";
import orgDetailsReducer from "./orgDetailsSlice";
import orgListReducer from "./orgListSlice";
import orgReducer from "./orgSlice";
// import userInfoReducer from "./userInfoSlice";
import authUserReducer from "./authUserSlice";
import layoutReducer from "./layoutSlice";

const store = configureStore({
  reducer: {
    loading: loadingReducer,
    org: orgReducer,
    orgList: orgListReducer,
    orgDetails: orgDetailsReducer,
    // user: userInfoReducer,
    authUser: authUserReducer, // New auth slice
    layout: layoutReducer,
  },
});

export default store;
